var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit-newsletter"}},[_c('h2',[_vm._v("Edit Bundle '"+_vm._s(_vm.name)+"'")]),_vm._v(" "),_c('bundle-form',{attrs:{"method":"PUT","bundleId":_vm.bundleId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49882fb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BundleEdit.vue
// module id = 1183
// module chunks = 1